import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import MaterialTable, { MTableToolbar } from 'material-table';
import { Container, createMuiTheme, Toolbar, Typography, CssBaseline, Tooltip, Snackbar, FormControl, InputLabel, Select, Divider, Fab, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ExportIcon from '@material-ui/icons/GetApp';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone, ConvertTimeZoneOffset } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Theme } from '../contexts/themeContext';
import typesData from '../../data';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    }
}));

export default function SafetyCoachingReport(props) {
    const classes = useStyles();
    const { defaultSite, sites } = useContext(Context);
    const { theme } = useContext(Theme);
    const [sitesList, setSitesList] = useState([]);
    const [safeUnsafeList, setSafeUnsafeList] = useState([]);
    const [categories, setCategories] = useState([]);
    const [startDate, setStartDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [endDate, setEndDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [siteId, setSiteId] = useState(0);
    const [safeUnsafe, setSafeUnsafe] = useState(-1);
    const [catagory, setCatagory] = useState("All");
    const [showFilter, setShowFilter] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const tableHeight = window.innerHeight - (showFilter ? 377 : 210);

    const [safetyCoachings, setSafetyCoachings] = useState({
        columns: [
            { field: 'SafetyCoachDateString', title: 'Date', width: '4%', render: rowData => moment(rowData.SafetyCoachDateString).format('MM/DD/YYYY') },
            { field: 'IsSafe', title: 'Safe/Unsafe', width: '3%', render: rowData => rowData.IsSafe ? 'Safe' : 'Unsafe' },
            { field: 'SiteName', title: 'Site Name', width: '18%' },
            { field: 'RetrainingCompleted', title: 'Retraining Completed', width: '3%', render: rowData => rowData.IsSafe ? 'N/A' : (rowData.RetrainingCompleted ? 'Yes' : 'No') },
            { field: 'Employee', title: 'Employee', width: '4%' },
            { field: 'JobTitle', title: 'Position', width: '4%' },
            { field: 'Supervisor', title: 'Supervisor', width: '10%' },
            { field: 'Category', title: 'Category', width: '10%' },
            { field: 'Activities', title: 'Activity', width: '10%' },
            { field: 'Comment', title: 'Comments', width: '4%' },
            { field: 'CreatedDateTime', title: 'Created Date/Time', width: '7%', render: rowData => ConvertTimeZoneOffset(rowData.CreatedDateTime, defaultSite) },
            { field: 'CreatedUser', title: 'Created User', width: '7%' },
            { field: 'ModifiedDateTime', title: 'Modified Date/Time', width: '7%', render: rowData => ConvertTimeZoneOffset(rowData.ModifiedDateTime, defaultSite) },
            { field: 'ModifiedUser', title: 'Modified User', width: '7%' }
        ],
        data: []
    });

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
    };

    const filterChanged = () => {
        setShowFilter(!showFilter);
    };

    const getSafetyCoachings = () => {
        let model = {};

        model.SiteId = siteId;
        model.DateStart = startDate;
        model.DateEnd = endDate;
        model.IsSafe = showFilter ? (safeUnsafe === -1) ? null : (safeUnsafe === 1 ? true : false) : null;
        model.Category = showFilter ? catagory : "";
        model.AccessibleSites = sitesList;
        setBackDrop(true);

        HttpService.post('/SafetyCoaching/GetSafetyCoachingsReport', model)
            .then((result) => {
                setSafetyCoachings({ ...safetyCoachings, data: result.data });
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const exportToExcel = () => {
        let model = {};
        let parameter = {};
        var index = sitesList.findIndex(item => item.id === siteId);

        parameter.SiteId = siteId;
        parameter.DateStart = startDate;
        parameter.DateEnd = endDate;
        parameter.IsSafe = showFilter ? (safeUnsafe === -1) ? null : (safeUnsafe === 1 ? true : false) : null;
        parameter.Category = showFilter ? catagory : "";
        parameter.AccessibleSites = sitesList;
        model.SafetyCoach = parameter;
        model.SiteName = sitesList[index].name;
        model.Hour = parseInt(defaultSite.offset);;
        model.TimeZoneDST = parseInt(defaultSite.dst);;
        model.DstStart = moment().month(2).day(0).format("MM/DD/YYYY");;
        model.DstEnd = moment().month(10).day(-7).format("MM/DD/YYYY");;
        setBackDrop(true);

        HttpService.post('/SafetyCoaching/ExportToCSV', model)
            .then((result) => {
                if (result.success) {
                    let fileName = result.name;
                    HttpService.downloadFile('/Report/DownloadFile', { fileName: fileName })
                        .then((response) => {
                            const url = window.URL.createObjectURL(new Blob([response]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            link.parentNode.removeChild(link);
                        });
                }
                else {
                    setSuccessMessage(result.message);
                    setOpenSuccess(true);
                }
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    useEffect(() => {
        if (sitesList.length > 0) {
            getSafetyCoachings();
        }
        // eslint-disable-next-line 
    }, [siteId, startDate, endDate, safeUnsafe, catagory]);

    useEffect(() => {
        let data = sites.slice();
        let index = sites.findIndex(item => item.id === 0);
        if (index === -1) {
            data.unshift({ id: 0, name: "All" });
            setSitesList(data);
        }

        data = [];
        data.push({ id: 1, value: -1, name: "All" });
        data.push({ id: 2, value: 1, name: "Safe" });
        data.push({ id: 3, value: 0, name: "Unsafe" });
        setSafeUnsafeList(data);

        data = typesData.Category.slice();
        index = data.findIndex(item => item.id === 0);
        if (index === -1) {
            data.unshift({ Id: 0, Key: "All" });
            setCategories(data);
        }
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        setSiteId(defaultSite.id);
        // eslint-disable-next-line 
    }, [sitesList]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="safetyCoachingBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            <Link to="/"><KeyboardBackspaceIcon /></Link>
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" className={classes.title}>&nbsp;Safety Coaching Report</Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end">
                                <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="export" onClick={exportToExcel}>
                                    <Tooltip title="Export" arrow><ExportIcon /></Tooltip>
                                </Fab>
                                <SmallMenu modified={false} />
                                <Tooltip title="Filter" arrow>
                                    <FilterListIcon style={{ cursor: "pointer", float: "right", width: "30px", marginTop: "20px", marginLeft: "20px" }} onClick={filterChanged} />
                                </Tooltip>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <div className={classes.root} autoComplete="off">
                                <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="StartDate"
                                                label="Start Date"
                                                format="MM/dd/yyyy"
                                                size="small"
                                                disableFuture="true"
                                                value={startDate}
                                                onChange={date => setStartDate(moment(date).format("MM/DD/YYYY"))}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="EndDate"
                                                label="End Date"
                                                format="MM/dd/yyyy"
                                                size="small"
                                                disableFuture="true"
                                                minDate={startDate}
                                                value={endDate}
                                                onChange={date => setEndDate(moment(date).format("MM/DD/YYYY"))}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                                {showFilter && <>
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="Site">Site</InputLabel>
                                        <Select
                                            native
                                            label="Site"
                                            size="small"
                                            value={siteId}
                                            onChange={(e) => { setSiteId(parseInt(e.target.value)); }}
                                        >
                                            {
                                                sitesList.map((option, key) => {
                                                    return <option key={option.id} value={option.id} label={option.name} >{option.name}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="SafeUnsafe">Safe/Unsafe</InputLabel>
                                        <Select
                                            native
                                            label="Safe/Unsafe"
                                            size="small"
                                            value={safeUnsafe}
                                            onChange={(e) => { setSafeUnsafe(parseInt(e.target.value)); }}
                                        >
                                            {
                                                safeUnsafeList.map((option, key) => {
                                                    return <option key={option.id} value={option.value} label={option.name} >{option.name}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="Category">Category</InputLabel>
                                        <Select
                                            native
                                            label="Category"
                                            size="small"
                                            value={catagory}
                                            onChange={(e) => { setCatagory(e.target.value); }}
                                        >
                                            {
                                                categories.map((option, key) => {
                                                    return <option key={option.Id} value={option.Key} label={option.Key} >{option.Key}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </>
                                }
                            </div>
                            <Divider style={{ height: '1px', backgroundColor: currentTheme.secondary, marginTop: '5px', marginBottom: '10px' }} />
                            <div style={{ maxWidth: '100%' }}>
                                <MaterialTable
                                    columns={safetyCoachings.columns}
                                    data={safetyCoachings.data}
                                    components={{
                                        Toolbar: (props) => (
                                            <div
                                                style={{
                                                    height: "0px",
                                                }}
                                            >
                                                <MTableToolbar {...props} />
                                            </div>
                                        )
                                    }}
                                    style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                    options={{
                                        filtering: false,
                                        search: false,
                                        paging: false,
                                        actionsColumnIndex: -1,
                                        minBodyHeight: tableHeight,
                                        maxBodyHeight: tableHeight,
                                        headerStyle: {
                                            fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                        },
                                        actionsCellStyle: {
                                            color: currentTheme.secondary,
                                            hover: 'white'
                                        },
                                        rowStyle: rowStyle
                                    }}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
